import React from 'react';

import FormattedNumber from '/component/base/FormattedNumber';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {DownlineProfile} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

//HIDDEN: CONNAPP-581
//import {showComingSoonToast} from '/util/toast.util';
import {styles} from './ProfileCreditsAndRewardsSection.style';

interface ProfileCreditsAndRewardsSectionProps {
  tt: (key: string, value?: any) => string;
  wellnessCreditsBalance: number;
  wellnessCreditsCurrencyCode: string;
  rewardsBalance: number;
  rewardsCurrencyCode: string;
}

export const ProfileCreditsAndRewardsSection = (
  props: ProfileCreditsAndRewardsSectionProps = {
    tt: withTranslation.ttDefaultProp,
    wellnessCreditsBalance: 0,
    wellnessCreditsCurrencyCode: '',
    rewardsBalance: 0,
    rewardsCurrencyCode: '',
  },
) => {
  const {
    tt,
    // wellnessCreditsBalance,
    // wellnessCreditsCurrencyCode,
    rewardsBalance,
    rewardsCurrencyCode,
  } = props;
  //Hiding wellness Credit from client profile for now

  // const creditsListItemProps = {
  //   readonly: false,
  //   onPress: () => showComingSoonToast('wellness credits'),
  //   style: {base: styles.listItem},
  // };

  // const wellnessCreditsLabel = (
  //   <Text allowFontScaling maxFontSizeMultiplier={2} useCompetency={true}>{tt('credits.label', 'Wellness Credits')}</Text>
  // );
  //
  // let rendererCreditsListItem = (
  //   <ListItem
  //     {...creditsListItemProps}
  //     label={wellnessCreditsLabel}
  //     suffix={
  //       <FormattedNumber value={0} currencyCode={'USD'} decimalPlaces={2} />
  //     }
  //   />
  // );

  // if (wellnessCreditsBalance > 0) {
  //   rendererCreditsListItem = (
  //     <ListItem
  //       {...creditsListItemProps}
  //       label={wellnessCreditsLabel}
  //       suffix={
  //         <FormattedNumber
  //           value={wellnessCreditsBalance}
  //           currencyCode={wellnessCreditsCurrencyCode}
  //           decimalPlaces={2}
  //         />
  //       }
  //     />
  //   );
  // }

  const rewardsListItemProps = {
    readonly: true,
    style: {
      base: {
        ...styles.listItem,
        ...styles.listItemWithBorder,
      },
    },
  };

  const rewardsLabel = (
    <Text allowFontScaling maxFontSizeMultiplier={2}>
      {tt('rewards.label', 'Rewards')}
    </Text>
  );

  let rendererRewardsListItem = (
    <ListItem
      {...rewardsListItemProps}
      label={rewardsLabel}
      suffix={
        <FormattedNumber
          testID={DownlineProfile.rewards}
          value={rewardsBalance}
          currencyCode={rewardsCurrencyCode ? rewardsCurrencyCode : 'USD'}
          decimalPlaces={2}
        />
      }
    />
  );

  return (
    <ProfileSection
      analyticsTitle="Rewards"
      style={{base: styles.base}}
      title={tt('heading', 'Rewards')}>
      {/*{rendererCreditsListItem}*/}
      {rendererRewardsListItem}
    </ProfileSection>
  );
};

export default ProfileCreditsAndRewardsSection;
